module.exports = require("@seddi/three/examples/jsm/postprocessing/EffectComposer.js");